import { Modal, Button, Table } from "antd";

interface IProps {
  visualizar: boolean;
  setVisualizar: any;
}
import Pdf from "../../../../../assets/pp/1PORTAFOLIO GENERAL ESTIMULOS PP CULTURA 28 abril 2025.pdf"

export const ModalVisualizarSocializaciones: React.FC<IProps> = (props: IProps) => {

  const onCancel = () => {
    props.setVisualizar(false)
  }

  const datosTabla = [
    { actividad: "Comuna 10, La Candelaria: Socialización convocatoria Estímulos PP 2025", fecha: "📆 Lunes 26 de Mayo", hora: "🕤 6:30 p.m.", link: "https://meet.google.com/fou-uumg-tju"},
    { actividad: "Comuna 12, La América: Socialización convocatoria Estímulos PP 2025", fecha: "📆 Lunes 26 de Mayo", hora: "🕤 6:30 p.m.", link: "https://meet.google.com/cyt-gwoh-mwe"},
    { actividad: "Comuna 4, Aranjuez: Socialización convocatoria Estímulos PP 2025", fecha: "📆 Martes 27 de Mayo", hora: "🕤 6:30 p.m.", link: "https://meet.google.com/uef-dzrn-hkw"},
    { actividad: "Comuna 8, Villa Hermosa: Socialización convocatoria Estímulos PP 2025", fecha: "📆 Martes 27 de Mayo", hora: "🕤 6:30 p.m.", link: "https://meet.google.com/zvb-pjxw-knz"},
    { actividad: "Comuna 70, Altavista: Socialización convocatoria Estímulos PP 2025", fecha: "📆 Miércoles 28 de Mayo", hora: "🕤 6:30 p.m.", link: "https://meet.google.com/ovx-pghg-iff"},
    { actividad: "Comuna 90, Santa Elena: Socialización convocatoria Estímulos PP 2025", fecha: "📆 Miércoles 28 de Mayo", hora: "🕤 9:00 a.m.", link: "https://meet.google.com/hgw-yyzk-wyw"},
    { actividad: "Comuna 60, San Cristóbal: Socialización convocatoria Estímulos PP 2025", fecha: "📆 Jueves 29 de Mayo", hora: "🕤 6:30 p.m.", link: "https://meet.google.com/rhw-vneq-kkb"},
    { actividad: "Comuna 9, Buenos Aires: Socialización convocatoria Estímulos PP 2025", fecha: "📆 Jueves 29 de Mayo", hora: "🕤 6:30 p.m.", link: "https://meet.google.com/pyh-gsey-rkf"},
    { actividad: "Comuna 70, Altavista: Socialización convocatoria Estímulos PP 2025", fecha: "📆 Viernes 30 de Mayo", hora: "🕤 9:00 a.m.", link: "📍Lugar: Casa de la Cultura Altavista"},
    { actividad: "Comuna 3, Manrique: Socialización convocatoria Estímulos PP 2025", fecha: "📆 Viernes 30 de Mayo", hora: "🕤 6:30 p.m.", link: "https://meet.google.com/idc-nzcw-ror"},
    { actividad: "Comuna 15, Guayabal: Socialización convocatoria Estímulos PP 2025", fecha: "📆 Viernes 30 de Mayo", hora: "🕤 6:30 p.m.", link: "https://meet.google.com/cqy-hehm-bdo"},
    { actividad: "Socialización convocatoria Estímulos PP 2025", fecha: "Miércoles 7 de Mayo", hora: "6:30 p.m.", link: "https://meet.google.com/njv-fkag-zfo"},
    { actividad: "Taller formulación de proyectos para la convocatoria de Estímulos PP 2025", fecha: "Jueves 8 de Mayo", hora: "6:30 p.m.", link: "https://meet.google.com/tyb-jbwm-hgj"},
    { actividad: "Socialización convocatoria Estímulos PP 2025", fecha: "Martes 13 de Mayo", hora: "6:30 p.m.", link: " https://meet.google.com/vpv-gnkw-axz"},
    { actividad: "Taller formulación de proyectos para la convocatoria de Estímulos PP 2025", fecha: "Miércoles 14 de Mayo", hora: "6:30 p.m.", link: "https://meet.google.com/rzf-xixd-dka"},
    { actividad: "Socialización convocatoria Estímulos PP 2025", fecha: "Lunes 19 de Mayo", hora: "6:30 p.m.", link: "https://meet.google.com/mpt-uuyw-mjn"},
    { actividad: "Socialización convocatoria Estímulos PP 2025", fecha: "Miércoles 21 de Mayo", hora: "6:30 p.m.", link: "https://meet.google.com/rdy-ysjt-wew"},
  ]

  const columns = [
      {
        title: "ACTIVIDAD",
        width: 450,
        dataIndex: "actividad",
        key: "actividad",
        render: (datos) => {
          return (
            <span style={{whiteSpace: "pre-line"}}>
              {datos}
            </span>
          );
        },
      },
      {
        title: "FECHA",
        width: 200,
        dataIndex: "fecha",
        key: "fecha",
        render: (datos) => {
          return (
            <span style={{whiteSpace: "pre-line"}}>
              {datos}
            </span>
          );
        },
      },
      {
        title: "HORA",
        width: 200,
        dataIndex: "hora",
        key: "hora",
        render: (datos) => {
          return (
            <span style={{whiteSpace: "pre-line"}}>
              {datos}
            </span>
          );
        },
      },
      {
        title: "LINK",
        width: 400,
        dataIndex: "link",
        key: "link",
        render: (datos) => {
          return (
            <span style={{whiteSpace: "pre-line"}}>
              <a target="_blank" href={datos}>{datos}</a>
            </span>
          );
        },
      },
    ];

  return (
    <Modal
      className="ant-modal-close-x2"
      maskStyle={{
        backgroundColor: "rgba(6, 100, 144 ,0.71)",
      }}
      visible={props.visualizar}
      onCancel={onCancel}
      width={1100}
      footer={[
        <Button key="B_CERRAR_1" className="button-gray-ghost m-0" onClick={onCancel}>
          Cerrar
        </Button>,
      ]}
      cancelButtonProps={{ style: { display: "none" } }}
    >
      <div style={{fontSize: '1.2em', textAlign: 'center' }}>
        <span className="pb-3 font-size-20px font-family-Montserrat-SemiBold">
            Socializaciones de portafolio 2025
        </span>
        <br />
        <div className="col-12">
          <Table
            style={{ borderTop: "1px solid #C4C4C4", fontSize: '16px' }}
            pagination={false}
            columns={columns}
            dataSource={datosTabla}
            size="middle"
            bordered={false}
            onRow={(record) => {
              return {
                style: {
                  cursor: 'pointer',
                },
              }
            }}
          />
        </div>
      </div>
    </Modal>
  );
};
